import { render, staticRenderFns } from "./simples-apuracao.vue?vue&type=template&id=44f20c77&scoped=true&"
import script from "./simples-apuracao.vue?vue&type=script&lang=js&"
export * from "./simples-apuracao.vue?vue&type=script&lang=js&"
import style0 from "./simples-apuracao.vue?vue&type=style&index=0&id=44f20c77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f20c77",
  null
  
)

export default component.exports